export default __webpack_public_path__ + "static/media/GC_3.4ade2c6a.png";